import React from 'react'
import Game from './Game'
import { render, getConfig, CONTENT_TYPE } from '@educaplay/core'
import { assetsUrl, GameProvider } from '@educaplay/core'
import { initialize } from '@educaplay/store'
import { normalizeString } from './utils/functions'
import { areTextsEqual, initErrorMonitoring } from '@educaplay/core/utils'
import { createCustomization } from '@educaplay/core/utils/customization'

initErrorMonitoring("https://fbbb34263457250a437a6a7434666883@o4509038211104768.ingest.de.sentry.io/4509045337882704")

const gameImage = assetsUrl("ADIVINANZA/logoActivity.png");
const container = document.getElementById('root');

async function init() {
  const { data, texts, settings, user, title, description, author, id, url } = await getConfig().catch((err) =>
    console.error('Error al obtener la configuración: ', err)
  )

  const { resources } = settings
  const unfilteredQuestions = data.PREGUNTAS
    .map((question, index) => ({ ...question, id: index }))
    .filter((question) => question.RESPUESTA && question.RESPUESTA.trim() !== "")

  const filteredQuestions = unfilteredQuestions.map(question => {
    const clues = question.PISTAS?.filter(clue => clue.TEXTO !== "" || (clue.MULTIMEDIA && clue.MULTIMEDIA !== "")) ?? null;
    return {
      ...question,
      PISTAS: clues
    }
  })

  const ADIVINANZA_SOUNDS = {
    "drag": assetsUrl('ADIVINANZA/arrastrar.mp3'),
    "goodActive": assetsUrl('ADIVINANZA/bienactivo.mp3'),
    "place": assetsUrl('ADIVINANZA/colocar.mp3'),
    "correct": assetsUrl('ADIVINANZA/correcto.mp3'),
    "climb": assetsUrl('ADIVINANZA/escalar.mp3'),
    "write": assetsUrl('ADIVINANZA/escribir.mp3'),
    "move": assetsUrl('ADIVINANZA/mover.mp3'),
    "clueimage": assetsUrl('ADIVINANZA/pista-desvelar.mp3'),
    "clue": assetsUrl('ADIVINANZA/pista.mp3'),
  }


  const questionTimeNumber = Number(data.TIEMPO)
  const questionTime = Number.isNaN(questionTimeNumber) ? 0 : questionTimeNumber
  const isCaseSensitive = data.SENSIBLE_MAYUSCULAS_ACENTOS === 'si';



  const questions = filteredQuestions.map(question => {
    const image = (question.MOSTRAR_IMAGEN === "si" && question.IMAGEN) ? `${resources}${question.IMAGEN}` : null;
    const clues = question.PISTAS?.map(clue => {
      return {
        text: clue.TEXTO,
        source: clue.MULTIMEDIA ? (clue.MULTIMEDIA_TIPO === CONTENT_TYPE.YOUTUBE ? clue.MULTIMEDIA : `${resources}${clue.MULTIMEDIA}`) : null,
        type: clue.MULTIMEDIA_TIPO ? clue.MULTIMEDIA_TIPO : CONTENT_TYPE.TEXT
      }
    }) ?? [];

    const checkAnswer = (answerObject) => {
      const answer = answerObject?.answer;
      if (!answer) return false;

      const correctAnswerToUpperCase = question.RESPUESTA.trim().toUpperCase();
      if (isCaseSensitive) {
        return areTextsEqual(answer, correctAnswerToUpperCase);
      } else {
        const normalizeAnswer = normalizeString(answer);
        const normalizeCorrectAnswer = normalizeString(correctAnswerToUpperCase);
        return areTextsEqual(normalizeAnswer, normalizeCorrectAnswer);
      }
    }

    const points = 100 / filteredQuestions.length;

    const calculatePoints = (answer) => {
      return Math.max(points - answer.pointsLose, 0);
    }

    return {
      bank: (question.ENUNCIADO || question.MULTIMEDIA) ? {
        text: question.ENUNCIADO,
        source: question.MULTIMEDIA ? (question.MULTIMEDIA_TIPO === CONTENT_TYPE.YOUTUBE ? question.MULTIMEDIA : `${resources}${question.MULTIMEDIA}`) : null,
        type: question.MULTIMEDIA_TIPO ? question.MULTIMEDIA_TIPO : CONTENT_TYPE.TEXT
      } : null,
      checkAnswer,
      correctAnswers: [question.RESPUESTA.trim()],
      clues,
      image,
      revealImage: question.DESVELAR_IMAGEN === "si" && !!image,
      revealLetters: question.DESVELAR_LETRAS === "si",
      answer: null,
      points,
      time: questionTime,
      id: question.id,
      calculatePoints,
      media: (question.MULTIMEDIA || image) ? {
        type: image ? CONTENT_TYPE.IMAGE : question.MULTIMEDIA_TIPO ?? null,
        src: image ? image : question.MULTIMEDIA ? `${resources}${question.MULTIMEDIA}` : null,
      } : null,
      text: question.ENUNCIADO,
    }
  });

  initialize({
    lives: data.NUMERO_INTENTOS, //COMPROBAR SI ES MAXIMO
    liveActived: data.NUMERO_INTENTOS_INFINITOS !== "si",
    hasCountDown: data.MAXIMO === "si",
    randomized: data.ALEATORIO === "si",
    showSolutions: data.OCULTAR_RESPUESTAS !== "1",
    showRestart: data.OCULTAR_REINICIAR !== "1",
    showSocialMedia: data.OCULTAR_REDES !== "1",
    finalText: data.TEXTO_FINAL,
    hasBank: questions.some(question => question.bank),
    countFooterSpace: true,
    hasInfinityTries: true,
    showUserTries: true,
    hasProgressBar: { view: true, onlyCorrect: true },
    questions,
    settings,
    title,
    description,
    author,
    id,
    url,
    user,
    customizations: createCustomization(data)
  });

  render(container, (
    <React.StrictMode>
      <GameProvider
        gameImage={gameImage}
        texts={texts}
        Game={Game}
        sounds={ADIVINANZA_SOUNDS}

        mappers={{
          report: (question) => {


            const isCorrect = question.checkAnswer(question.answer)
            const questionID = question.id;

            const triesArray = question.tries.map(entry => {
              return {
                s: false,
                i: questionID,
                a: entry.answer
              }
            });

            const answer = {
              s: isCorrect,
              i: questionID,
              a: question.answer.answer
            }

            return [...triesArray, answer];
          }
        }}

        renders={{
          infoLeft: (currentIndex, questions) => {
            return `${texts.specific.riddle}: ${currentIndex + 1} / ${questions.length}`
          },
        }}
      />
    </React.StrictMode>
  ))
}

init();